import { render } from "./saveCommune.vue?vue&type=template&id=61d79e5d&scoped=true"
import script from "./saveCommune.vue?vue&type=script&lang=js"
export * from "./saveCommune.vue?vue&type=script&lang=js"

import "./saveCommune.vue?vue&type=style&index=0&id=61d79e5d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d79e5d"]])

export default __exports__